import { makeVar } from "@utils/reactiveVar";
import {
  Competency,
  GradebookConfig,
  GradingComponent,
  Subskill,
} from "@services/shared";
import { CourseModel } from "../../components/models/course/CourseModel";
import { CatalogModel } from "@components/models/catalog/CatalogModel";
import { GradeLevelModel } from "@components/models/grade-level/GradeLevelModel";
import { SchoolYearModel } from "@components/models/school-year/SchoolYearModel";
import { CurriculumModel } from "@components/models/curriculum/CurriculumModel";
import { ProgramLookUpModel } from "@components/models/lookups/ProgramLookUpModel";
import { SubjectModel } from "@components/models/subject/SubjectModel";
import { AccreditationLookUpModel } from "@components/models/lookups/AccreditationLookUpModel";
import { CourseStatusOptions } from "../../../typings/types";
import { LookUpModel } from "@components/models/lookups/LookUpModel";
import { SkillModel } from "@components/models/behavior/SkillModel";
import { TeacherModel } from "@components/models/teacher/TeacherModel";
import { ClassModel } from "@components/models/class/class";

//PROPS
export type Meta = {
  pageNumber?: number;
  per_page?: number;
  total_count?: number;
  total_pages?: number;
  next_page?: 2;
  prev_page?: number;
  records?: number;
};

export type Courses = {
  courses?: CourseModel[];
  next_page_token?: string;
  meta?: Meta;
};

export type Catalogs = {
  catalogs?: CatalogModel[];
  meta?: Meta;
};

// LOGIN
export const roleVar = makeVar<
  "teacher" | "student" | "registrar" | "parent" | "parent-teacher" | "admin" | null
>(null);

// admin global state/var
export const pageVar = makeVar<number>(1); //generic page value [if there is multiple "page" propos on a screen, define new va to avoid conflict]
export const fetchingVar = makeVar<boolean>(false);

export const adminGradebooksVar = makeVar([]); // list of adminGradebook
export const adminGradebookVar = makeVar<GradebookConfig | null>(null); // individual adminGradebook
export const curriculumsVar = makeVar<any[]>([]); // individual adminGradebook
export const availableCurriculumAdminGradebookVar = makeVar<any[]>([]); // individual adminGradebook
export const adminGradebookCompetencyVar = makeVar<Competency | null>(null); // list of adminGradebook

// COURSE-MANAGEMENT STATES
export const coursesVar = makeVar<Courses>({});
export const approvedCoursesVar = makeVar<Courses>({});
export const courseManagemenActiveTab = makeVar<any[]>([]);
export const copiedCourseVar = makeVar<CourseModel | null>(null);
export const courseCatalogOptionsVar = makeVar<CatalogModel[]>([]);

export const catalogsVar = makeVar<Catalogs>({});
export const catalogAddedCoursesVar = makeVar<string[]>([]);
export const selectedCatalogVar = makeVar<CatalogModel>({});
export const catalogAvailableCourseTabVar = makeVar<"available-courses" | "added-courses">(
  "available-courses",
);

export const catalogAssignedTeachersVar = makeVar<string[]>([]);
export const catalogAssignedTeachersTabVar = makeVar<"available-teachers" | "assigned-teachers">(
  "available-teachers",
);

export const catalogAssignedParentTeachersVar = makeVar<string[]>([]);
export const catalogAssignedParentTeachersTabVar = makeVar<
  "available-parent-teachers" | "assigned-parent-teachers"
>("available-parent-teachers");

export const catalogVar = makeVar<CatalogModel>({});

export const lookupVar = makeVar<{
  gradeLevels?: GradeLevelModel[];
  schoolYearsFull?: SchoolYearModel[];
  curriculums?: CurriculumModel[];
  programs?: ProgramLookUpModel[];
  subjects?: SubjectModel[];
  accreditations?: AccreditationLookUpModel[];
  courseStatus?: CourseStatusOptions[];
  organizations?: LookUpModel[];
  schoolYears?: LookUpModel[];
  gradeApprovalStatus?: LookUpModel[];
  skills?: SkillModel[];
  subSkills?: Subskill[];
  teachers?: TeacherModel[];
  gradingComponent?: GradingComponent[];
  objectiveType?: LookUpModel[];
  catalogs?: CatalogModel[];
  classes?: ClassModel[];
  approvedCourses?: CourseModel[];
}>({});
